import { generateRandomString } from "../hooks/General";
import {
  ClinetBankDataIcon,
  TrustedUserIcon,
  LastDepositIcon,
  MonthlyStatementIcon,
  UserCardIcon,
  NameCheckIcon,
  TransactionFailuresIcon,
  BlockListIcon,
  IconCryptoDashboard,
  IconCustomerWallets,
  IconTransactionHistory,
  IconAddress,
  UserSegmentsIcon,
  UserDetailsIcon,
} from "../utils/icons";

export const labels = {
  superadmin: "Superadmin",
  admin: "Admin",
  member: "Member",
  customer_service: "Customer Service",
  finance: "Finance",
  support_agent: "Support Agent",
};
export const paymentMethods = ["citizen", "interac", "bank", "skrill", "muchbetterwallet", "citizen_verified"];

const url = process.env.REACT_APP_API_URL;
export const apiUrl = {
  TRANSACTIONS: `${url}/v1/transaction_list/get?`,
  REFRESH_TOKEN: `${url}/v1/refresh_token`,
  REQUEST_WITHDRAWAL: `${url}/v1/requested_withdrawal/get`,
  CHANGE_STATUS_WITHDRAWALS: `${url}/v1/requested_withdrawal/change_status`,
  CHANGE_PAYMENT_METHOD: `${url}/v1/requested_withdrawal/change_payment_method`,
  SAVE_TRANSACTION_DETAILS: `${url}/v1/transactions/edit`,
  CREATE_VENDORS: `${url}/v1/create/vendors`,
  EMAIL_GET: `${url}/v1/emails/get/all`,
  DELETE_GENERAL: `${url}/v1/general/delete`,
  SAVE_SETTINGS: `${url}/v1/settings/save`,
  GET_USER_LIST: `${url}/v1/user/list`,
  INVITE_USER: `${url}/v1/invite/user`,
  GET_SETTINGS: `${url}/v1/settings/get`,
  SETUP_MFA_API: `${url}/v1/mfa/setup_mfa`,
  SAVE_DOMAIN: `${url}/v1/partner/domain/save`,
  SAVE_API_KEY: `${url}/v1/partner/api_key/save`,
  CHECK_OUT_TOKEN_PAYMENT: `${url}/v1/payment/checkout/get_token`,
  CHECK_OUT_TOKEN_WITHDRAWAL: `${url}/v1/withdrawal/checkout/get_token`,
  GET_COUNTRIES: `${url}/v1/countries/get`,
  EDIT_CREDENTIALS: `${url}/v1/edit/credentials`,
  SAVE_VENDORS: `${url}/v1/edit/vendors`,
  GET_FILTERS: `${url}/v1/get/filters`,
  OVERRIDE_TRANSACTION: `${url}/v1/edit/override_transaction`,
  RESEND_CURRENT_STATUS: `${url}/v1/edit/resend_current_status`,
  PROVIDER_WEBHOOK_HISTORY: `${url}/v1/get/list/provider_webhook_history`,
  USERS_CARDS: `${url}/v1/get/list/users_cards`,
  NAME_CHECK: `${url}/v1/get/list/name_check`,
  VENDORS: `${url}/v1/get/list/vendors`,
  GET_CARD_DETAILS: `${url}/v1/get/list/pci_card_details`,
  MONTHLY_STATEMENT: `${url}/v1/get/list/monthly-statement`,
  USERS_LAST_DEPOSIT: `${url}/v1/get/list/users_last_deposit`,
  VENDORS_FOR_USER: `${url}/v1/get/list/vendors_for_user`,
  EDIT_USER_BANK_DATA: `${url}/v1/edit/user_bank_data`,
  // GET_SETTINGS: `${url}/v1/get/list/settings`,
};
export const cardProviders = [
  "payment_center",
  "paysafe",
  "omni",
  "praxis",
  "omni_v2",
  "sirpaga",
  "gate_express_payin",
  "payment_center_server",
  "card_paymentz",
  "gembyte_direct",
  "rapyd",
  "nuvei",
  "pagora",
  "unicorn",
  "hutch",
  "citizen",
  "citizen_verified",
  "crypton_pay_card",
  "libernetix_cards",
  "gumballpay",
  "bridge_open_banking",
  "truevo",
  "nuvei_applepay",
  "compustar",
  "pionpay",
  "transfr",
  "pay_masters_cards",
  "mids",
  "cashbulls",
  "paytently",
  "klyme",
  "nixxe_open_banking",
  "matrix",
  "sasono",
  "paysafe_applepay",
  "transactworld",
  "trust_payments",
  "debitly",
  "invictus",
  "trustist",
  "wpay_cards",
  "process_transact",
  "turbo_havale_papel",
  "volt",
  "luqa_pay_credit_cards",
  "plytech",
  "libernetix_googlepay",
  "rapyd_applepay",
  "axipays",
  "rillpay_card",
  "rillpay_applepay",
  "rillpay_googlepay",
  "trust_ftd",
  "reliance_pays",
  "pylonpay",
  "pylonpay_applepay",
  "pylonpay_googlepay",
  "finera_applepay",
  "finera_googlepay",
  "finera_open_banking",
  "wpay_hpp",
  "rillpay_open_banking",
  "plytech_open_banking",
];
export const ftdProviders = [...cardProviders, "sebestech_blik"];
export const currencies = [
  "AED",
  "ARS",
  "AUD",
  "BDT",
  "BHD",
  "BRL",
  "CAD",
  "CHF",
  "CNY",
  "COP",
  "CRC",
  "DKK",
  "EUR",
  "GBP",
  "GTQ",
  "IDR",
  "INR",
  "JPY",
  "KRW",
  "KWD",
  "MXN",
  "MYR",
  "MNT",
  "NOK",
  "NZD",
  "OMR",
  "PEN",
  "PHP",
  "PLN",
  "QAR",
  "SAR",
  "SEK",
  "SGD",
  "THB",
  "TRY",
  "TWD",
  "USD",
  "VND",
  "ZAR",
];
export const providerTransactionType = {
  apcopay: "deposit",
  bank: "deposit",
  citizen: "both",
  crypto_moralis: "both",
  citizen_verified: "both",
  interac: "both",
  manual_bank_transfer: "withdrawal",
  muchbetterwallet: "both",
  noda_pay: "both",
  omni: "deposit",
  omni_v2: "deposit",
  payment_center: "deposit",
  payoro: "withdrawal",
  paysafe: "both",
  praxis: "deposit",
  skrill: "both",
  unison: "withdrawal",
  juno: "withdrawal",
  kingdom: "withdrawal",
  crypto_walletconnect: "both",
  sirpaga: "deposit",
  gate_express: "withdrawal",
  vimoni: "deposit",
  payop: "deposit",
  gate_express_payin: "deposit",
  payment_center_server: "deposit",
  nixxe_simulator: "both",
  equals: "deposit",
  poli_bank_transfer: "deposit",
  new_age_crypto: "deposit",
  card_paymentz: "deposit",
  zen: "deposit",
  truelayer: "both",
  flexepin: "deposit",
  flash_1voucher: "both",
  flash_fnb: "deposit",
  bp_wallet: "deposit",
  gembyte_direct: "deposit",
  rapyd: "both",
  nuvei: "both",
  mercado: "withdrawal",
  bvnk_crypto: "deposit",
  instaxexchange: "deposit",
  hutch: "both",
  swiffy_eft: "deposit",
  pagora: "deposit",
  swiffy_worldsafepay: "both",
  unicorn: "deposit",
  crypton_pay_card: "deposit",
  crypton_pay_crypto: "both",
  luxon_pay: "both",
  sebestech: "withdrawal",
  libernetix_cards: "both",
  gumballpay: "both",
  numinio: "deposit",
  bridge_open_banking: "deposit",
  truevo: "deposit",
  nuvei_applepay: "both",
  compustar: "deposit",
  spinbillz: "both",
  pionpay: "deposit",
  transfr: "deposit",
  pay_masters: "deposit",
  pay_masters_cards: "deposit",
  mids: "deposit",
  cashbulls: "deposit",
  wert: "deposit",
  paytently: "deposit",
  klyme: "deposit",
  nixxe_open_banking: "both",
  debitly: "both",
  proccessing_0x: "both",
  gate_express_ob: "both",
  matrix: "both",
  sasono: "deposit",
  help2pay: "both",
  volt: "deposit",
  paysafe_applepay: "both",
  transactworld: "deposit",
  trust_payments: "both",
  rapyd_applepay: "deposit",
  ozow: "both",
  ozow_one_api: "deposit",
  invictus: "deposit",
  trustist: "deposit",
  wpay_cards: "deposit",
  ott: "both",
  matrix_pix: "deposit",
  trust_payments_applepay: "deposit",
  turbo_havale: "both",
  turbo_havale_papel: "both",
  transact365: "both",
  payshap: "withdrawal",
  process_transact: "deposit",
  inpay: "withdrawal",
  libernetix_googlepay: "deposit",
  guvenli_qr: "deposit",
  luqa_pay_credit_cards: "deposit",
  pnp: "both",
  luqa_pay_havale: "both",
  luqa_pay_instant_qr: "both",
  luqa_pay_ecopayz: "both",
  hemen_havale: "both",
  otomonay: "both",
  everest: "deposit",
  payswiss: "deposit",
  paysafe_googlepay: "both",
  plytech: "both",
  incas: "both",
  copo_pay: "both",
  axipays: "deposit",
  sebestech_blik: "deposit",
  rillpay_card: "deposit",
  rillpay_applepay: "deposit",
  rillpay_googlepay: "deposit",
  rillpay_open_banking: "both",
  trust_ftd: "deposit",
  reliance_pays: "deposit",
  pylonpay: "deposit",
  pylonpay_applepay: "deposit",
  pylonpay_googlepay: "deposit",
  finera_applepay: "deposit",
  finera_googlepay: "deposit",
  finera_open_banking: "deposit",
  wpay_hpp: "deposit",
  plytech_open_banking: "deposit",
};

export const transactionStatuses = {
  successful: "Successful",
  rejected: "Rejected",
  pending_approval: "Pending",
  cancelled: "Rejected",
  pending: "Pending",
  expired: "Expired",
};

export const nixxeCryptoNavigationData = {
  name: "Nixxe Crypto",
  sub_menu: [
    {
      title: "",
      list: [
        ...(process.env.REACT_APP_STAGE === "dev"
          ? [
              {
                name: "Dashboard",
                icon: IconCryptoDashboard,
                link: "/crypto-dashboard",
                key: "crypto_dashboard",
                action: "REPORTS",
              },
            ]
          : []),
        {
          name: "Customer Wallets",
          icon: IconCustomerWallets,
          link: "/customer-wallets",
          key: "customer_wallets",
          action: "REPORTS",
        },
        {
          name: "Transaction History",
          icon: IconTransactionHistory,
          link: "/transaction-history",
          key: "transaction_history",
          action: "REPORTS",
        },
        {
          name: "Wallet Address",
          icon: IconAddress,
          link: "/wallet-address",
          key: "wallet_address",
          action: "REPORTS",
        },
      ],
    },
  ],

  button_content: "",
};

export const reportNavigationData = {
  name: "Reporting",
  sub_menu: [
    {
      title: "",
      list: [
        {
          name: "Generated Reports",
          icon: MonthlyStatementIcon,
          link: "/generated-reports",
          key: "generated_reports",
          action: "REPORTS",
        },
        {
          name: "Last Deposit",
          icon: LastDepositIcon,
          link: "/users-last-deposit",
          key: "users_last_deposit",
          action: "REPORTS",
        },
        {
          name: "Monthly Statement",
          icon: MonthlyStatementIcon,
          link: "/monthly-statement",
          key: "monthly_statement",
          action: "REPORTS",
        },
        {
          name: "Users Cards",
          icon: UserCardIcon,
          link: "/users-cards",
          key: "users_cards",
          action: "REPORTS",
        },
        {
          name: "Name Check",
          icon: NameCheckIcon,
          link: "/name-check",
          key: "name_check",
          action: "REPORTS",
        },
        {
          name: "Transaction Failures",
          icon: TransactionFailuresIcon,
          link: "/transaction-failures",
          key: "transaction_failures",
          action: "REPORTS",
        },
      ],
    },
  ],

  button_content: "",
};
export const userNavigationData = {
  name: "Client Information",
  sub_menu: [
    {
      title: "",
      list: [
        {
          name: "Client Bank Data",
          icon: ClinetBankDataIcon,
          link: "/user-bank-data",
          key: "user_bank_data",
          action: "CLIENT_INFORMATION",
          excludeRoles: ["customer_service"],
        },
        {
          name: "Trusted Users",
          icon: TrustedUserIcon,
          link: "/trusted-users",
          key: "trusted_users",
          action: "CLIENT_INFORMATION",
        },
        {
          name: "Blocklist",
          icon: BlockListIcon,
          link: "/blocklist",
          key: "blocklist",
          action: "CLIENT_INFORMATION",
          excludeRoles: ["customer_service", "finance"],
        },
        {
          name: "User Segments",
          icon: UserSegmentsIcon,
          link: "/user-segments",
          key: "user_segments",
          action: "CLIENT_INFORMATION",
          excludeRoles: ["customer_service", "finance"],
        },
        {
          name: "User Details",
          icon: UserDetailsIcon,
          link: "/user-details",
          key: "user_details",
          action: "CLIENT_INFORMATION",
          excludeRoles: ["customer_service"],
        },
        {
          name: "Shared Card Activity",
          icon: UserCardIcon,
          link: "/shared-card-activity",
          key: "shared_card_activity",
          action: "CLIENT_INFORMATION",
        },
      ],
    },
  ],
  button_content: "",
};
export const cardsType = {
  all: "All",
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
};
export const routingCardsProvider = [
  "sirpaga",
  "omni_v2",
  "paysafe",
  "gate_express_payin",
  "payment_center_server",
  "card_paymentz",
  "gembyte_direct",
  "rapyd",
  "nuvei",
  "pagora",
  "unicorn",
  "crypton_pay_card",
  "libernetix_cards",
  "gumballpay",
  "truevo",
  "compustar",
  "pionpay",
  "transfr",
  "pay_masters_cards",
  "mids",
  "paytently",
  "matrix",
  "sasono",
  "transactworld",
  "trust_payments",
  "debitly",
  "invictus",
  "wpay_cards",
  "process_transact",
  "luqa_pay_credit_cards",
  "axipays",
  "rillpay_card",
  "reliance_pays",
  "pylonpay",
];
export const reportingSubMenu = [
  {
    name: "Generated Reports",
    icon: "",
    link: "/generated-reports",
    key: "generated_reports",
  },
  {
    name: "Last Deposit",
    icon: "",
    link: "/users-last-deposit",
    key: "users_last_deposit",
  },
  {
    name: "Monthly Statement",
    icon: "",
    link: "/monthly-statement",
    key: "monthly_statement",
  },
  {
    name: "Users Cards",
    icon: "",
    link: "/users-cards",
    key: "users_cards",
  },
  {
    name: "Name Check",
    icon: "",
    link: "/name-check",
    key: "name_check",
  },
];

export const nixxeCryptoSubMenu = [
  ...(process.env.REACT_APP_STAGE === "dev"
    ? [
        {
          name: "dashboard",
          icon: "",
          link: "/crypto-dashboard",
          key: "crypto_dashboard",
        },
      ]
    : []),
  {
    name: "Customer Wallets",
    icon: "",
    link: "/customer-wallets",
    key: "customer_wallets",
  },
  {
    name: "Transaction History",
    icon: "",
    link: "/transaction-history",
    key: "transaction_history",
  },
  {
    name: "Address",
    icon: "",
    link: "/address",
    key: "address",
  },
];

export const usersSubMenu = [
  {
    name: "Client Bank Data",
    icon: "",
    link: "/user-bank-data",
    key: "user_bank_data",
  },
  {
    name: "Trusted Users",
    icon: "",
    link: "/trusted-users",
    key: "trusted_users",
  },
];
export const mainMenu = [
  {
    role: "GLOBAL_SEARCH",
    url: "/global-search",
    show_nav_menu: true,
    menu_page: "Global Search",
    active_page: "global_search",
    name: "Global Search",
    sub_menu_list: [],
  },
  {
    role: "TRANSACTION_LIST",
    url: "/dashboard",
    show_nav_menu: true,
    menu_page: "Dashboard",
    active_page: "dashboard",
    name: "Dashboard",
    sub_menu_list: [],
  },
  {
    role: "TRANSACTION_LIST",
    url: "/transaction-list",
    show_nav_menu: true,
    menu_page: "Transaction List",
    active_page: "transactionList",
    name: "Transactions",
    sub_menu_list: [],
  },
  ...(process.env.REACT_APP_STAGE === "dev"
    ? [
        {
          role: "CLIENT_INFORMATION",
          url: "/crypto-dashboard",
          show_nav_menu: true,
          menu_page: "Nixxe Crypto",
          active_page: "nixxe_crypto",
          sub_menu_list: nixxeCryptoSubMenu,
          excludeRoles: ["support_agent"],
        },
      ]
    : []),
  {
    role: "TRANSACTION_LIST",
    url: "/requested-withdrawal",
    show_nav_menu: false,
    menu_page: "",
    active_page: "request_withdrawal",
    name: "Withdrawal Approvals",
    sub_menu_list: [],
  },
  {
    role: "CLIENT_INFORMATION",
    url: "/user-bank-data",
    show_nav_menu: true,
    menu_page: "Client Information",
    active_page: "user_bank_data",
    sub_menu_list: usersSubMenu,
  },
  {
    role: "REPORTS",
    url: "/users-last-deposit",
    show_nav_menu: true,
    menu_page: "Reporting",
    active_page: "reporting",
    sub_menu_list: reportingSubMenu,
  },
  {
    role: "CLIENT_PROFILE",
    url: "/settings",
    show_nav_menu: true,
    menu_page: "Settings",
    active_page: "settings",
    sub_menu_list: [],
  },
];
export const filterStatuses = [
  {
    value: "successful",
    name: "Successful",
  },
  {
    value: "pending",
    name: "Pending",
  },
  {
    value: "failed",
    name: "Failed",
  },
  {
    value: "expired",
    name: "Expired",
  },
  {
    value: "executing",
    name: "Executing",
  },
  {
    value: "cancelled",
    name: "Cancelled",
  },
  {
    value: "rejected",
    name: "Rejected",
  },
];
export const mockedRequestDetails = {
  theme: "light",
  language: "en",
  settings: {
    status_url: `${process.env.REACT_APP_REST_API_URL}/v1/test/notify`,
    return_url: `${process.env.REACT_APP_URL}`,
  },
  user_id: 123,
  tracking_id: generateRandomString(15),
  ip: "127.0.0.1",
  currency: "EUR",
  amount: 25,
  amount_restricted: false,
  customer: {
    first_name: "John",
    last_name: "Doe",
    email:
      process.env.REACT_APP_TITLE?.toLowerCase()?.indexOf("nixxe") > -1
        ? "johnnixxe@mailinator.com"
        : "johnnumipay@mailinator.com",
    zip_code: "D2",
    address: "46 Kildare Street",
    city: "Dublin",
    dob: "01/01/2000",
    max_deposit_limit: "",
    kyc_status: "passed",
    phone: {
      country: "IE",
      number: "111222333",
      prefix: "353",
    },
    country_code: "GB",
  },
};
export const restrictedPaths = [
  "/login",
  "/forgot_password",
  "/change_password",
  "/new_password",
  "/mfa_signin",
  "/mfa_setup",
  "/terms",
  "/generate_payment_links",
  "/support-login",
  "/support-expired",
];
export const dashboardSelectOptions = [
  { value: "24h", name: "Last 24h" },
  { value: "7days", name: "Last 7 Days" },
  { value: "current_month", name: "Current Month" },
  { value: "previous_month", name: "Previous Month" },
  { value: "previous_quarter", name: "Previous Quarter" },
  { value: "custom_range", name: "Custom Range" },
];
export const currenciesSymbol = {
  EUR: "€",
  USD: "$",
  CAD: "C$",
  NZD: "NZ$",
  GBP: "£",
  BRL: "R$",
  AUD: "AU$",
  JPY: "¥",
  SEK: "SEK",
  NOK: "NOK",
  DKK: "DKK",
  TRY: "₺",
  ZAR: "ZAR",
  PLN: "zł",
  MYR: "RM",
  MNT: "₮",
  BDT: "৳",
  CNY: "¥",
  IDR: "Rp",
  INR: "₹",
  KRW: "₩",
  PHP: "₱",
  SGD: "S$",
  TWD: "NT$",
  THB: "฿",
  VND: "₫",
  ARS: "$",
  COP: "$",
  CRC: "₡",
  GTQ: "Q",
  MXN: "$",
  PEN: "S/",
  AED: "د.إ",
  BHD: "د.ب",
  KWD: "د.ك",
  OMR: "ر.ع.",
  QAR: "QR",
  SAR: "﷼",
  CHF: "CHF",
};
export const additionalRulesName = {
  payout_less_than: "Payout less than",
  payout_greater_than: "Payout greater than",
};
export const payMastersPaymentMethods = [
  "BASIC_CARD",
  "CRYPTO",
  "FLEXEPIN",
  "MACROPAY",
  "SKRILL",
  "PAYRETAILERS",
  "LOCALPAYMENT",
  "MONNET",
  "PAYPAL",
  "NETELLER",
  "TRUSTPAYMENTS",
  "PAYMAXIS",
  "GATE8TRANSACT",
  "TINK",
  "B2BINPAY",
  "CLICK",
  "MONETIX",
  "PERFECTMONEY",
  "VOLT",
  "KESSPAY",
  "BILLLINE",
  "NGENIUS",
  "ASTROPAY",
  "ALYCEPAY",
  "PIX",
  "BOLETO",
  "UPI",
  "PAYTM",
  "NETBANKING",
  "FINRAX",
  "SPOYNT",
  "XINPAY",
  "OMNIMATRIX",
  "DPOPAY",
  "EXTERNAL_HPP",
  "XANPAY",
  "INRPAY",
  "ARI10",
  "SOFORT",
  "GIROPAY",
  "PAYSAFECARD",
  "PAYSAFECASH",
  "OPEN_BANKING",
  "KLARNA",
  "SPEI",
  "PAYCASH",
  "RAPIPAGO",
  "PAGOFACIL",
  "RAPIDTRANSFER",
  "MOBILE_MONEY",
  "INTERAC",
  "INTERAC_ETO",
  "INTERAC_RTO",
  "INTERAC_ACH",
  "PICPAY",
  "MOLLIE",
  "TED",
  "ZIPAY",
  "PSE",
  "EFECTY",
  "BANKTRANSFER",
  "PEC",
  "OXXO",
  "WEBPAY",
  "PAGOEFECTIVO",
  "MIFINITY",
  "PAYPORT",
  "JETONCASH",
  "JETONWALLET",
  "NODA",
  "NODA_REVOLUT",
  "ALFAKIT",
  "PAYFUN",
  "EMANAT",
  "M10",
  "RUBPAY",
  "MONERCHY",
  "MUCHBETTER",
  "YAPILY",
  "INAI",
  "IMPS",
  "RTGS",
  "PAYID",
  "ZOTAPAY",
  "SBP",
  "P2P_CARD",
  "P2P_IBAN",
  "P2P_SBP",
  "P2P_MOBILE",
  "PUSH",
  "GATEIQ",
  "VIETTEL",
  "ZALO",
  "QR",
  "CUP",
  "CODI",
  "PAY2PLAY",
  "BKASH",
  "NAGAD",
  "ROCKET",
  "VIRTUAL_ACCOUNT",
  "MULTIBANCO",
  "BLIK",
  "MBWAY",
  "P24",
  "MISTERCASH",
  "MACH",
  "KHIPU",
  "NEFT",
  "STICPAY",
  "SBERPAY",
  "MOBILE_COMMERCE",
  "BINANCE_PAY",
  "MPAY",
  "CHEK",
  "KLAP_EFECTIVO",
  "KLAP_TRANSFERENCIA",
  "PAGO46",
  "HITES",
  "SERVIFACIL",
  "OPENPAYD",
  "FAWRY",
  "EPS",
  "IDEAL",
  "TRUSTLY",
  "USSD",
  "MPESA",
  "ENAIRA",
  "ONEVOUCHER",
  "BANCONTACT",
  "SWISH",
  "EFT",
  "GCASH",
  "PAYMAYA",
  "PAGO_MOVIL",
  "PAGO_MOVIL_INST",
  "BIOPAGO",
  "CASH",
  "VOUCHERRY",
  "APPLEPAY",
  "GOOGLEPAY",
  "BRITE",
  "VOUCHSTAR",
  "REVOLUT",
  "PAYOUT_SEPA_BATCH",
  "PAYOUT_NONSEPA_REQUEST",
];
export const defaultRowsPerPage = 50;

export const checkoutLanguages = [
  { code: "en", name: "English" },
  { code: "de", name: "German" },
  { code: "fr", name: "French" },
  { code: "es", name: "Spanish" },
  { code: "tr", name: "Turkish" },
  { code: "sq", name: "Albanian" },
  { code: "ru", name: "Russian" },
];

export const normalizeCheckoutLanguage = (value) => {
  if (typeof value !== "string") return "en";
  const base = value.trim().toLowerCase().split(/[-_]/)[0];
  return checkoutLanguages.some((language) => language.code === base) ? base : "en";
};
export const rowsPerPageOptions = [50, 100, 200];
export const swiffyWorldSafePayPaymentMethods = [
  { "capitec-pay": "CapitecPay (ZAR)" },
  { "pay-card": "Card (ZAR)" },
  { cryptopay: "Crypto" },
  { "atm-deposit": "ATM Payment (ZAR)" },
  { "bank-deposit": "Manual Deposit (ZAR)" },
  { "instant-eft": "Instant EFT (ZAR)" },
  { nedbank: "Nedbank (ZAR)" },
  { applepay: "ApplePay (ZAR)" },
  { googlepay: "GooglePay (ZAR)" },
];
export const transact365PaymentMethods = [
  "BANK_TRANSFER",
  "WALLETS",
  "QR_CODE",
  "VIRTUAL_ACCOUNT",
  "UPI",
  "FPX",
  "DUITNOW",
  "TRUEMONEY",
  "MOMOPAY",
  "PIX",
  "CASH",
  "BEP20",
  "ERC20",
  "TRC20",
  "OPEN_BANKING",
];

export const phonePrefixes = [
  { code: "+1", country: "United States / Canada" },
  { code: "+7", country: "Russia / Kazakhstan" },
  { code: "+20", country: "Egypt" },
  { code: "+27", country: "South Africa" },
  { code: "+30", country: "Greece" },
  { code: "+31", country: "Netherlands" },
  { code: "+32", country: "Belgium" },
  { code: "+33", country: "France" },
  { code: "+34", country: "Spain" },
  { code: "+36", country: "Hungary" },
  { code: "+39", country: "Italy" },
  { code: "+40", country: "Romania" },
  { code: "+41", country: "Switzerland" },
  { code: "+43", country: "Austria" },
  { code: "+44", country: "United Kingdom" },
  { code: "+45", country: "Denmark" },
  { code: "+46", country: "Sweden" },
  { code: "+47", country: "Norway" },
  { code: "+48", country: "Poland" },
  { code: "+49", country: "Germany" },
  { code: "+51", country: "Peru" },
  { code: "+52", country: "Mexico" },
  { code: "+53", country: "Cuba" },
  { code: "+54", country: "Argentina" },
  { code: "+55", country: "Brazil" },
  { code: "+56", country: "Chile" },
  { code: "+57", country: "Colombia" },
  { code: "+58", country: "Venezuela" },
  { code: "+60", country: "Malaysia" },
  { code: "+61", country: "Australia" },
  { code: "+62", country: "Indonesia" },
  { code: "+63", country: "Philippines" },
  { code: "+64", country: "New Zealand" },
  { code: "+65", country: "Singapore" },
  { code: "+66", country: "Thailand" },
  { code: "+81", country: "Japan" },
  { code: "+82", country: "South Korea" },
  { code: "+84", country: "Vietnam" },
  { code: "+86", country: "China" },
  { code: "+90", country: "Turkey" },
  { code: "+91", country: "India" },
  { code: "+92", country: "Pakistan" },
  { code: "+93", country: "Afghanistan" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+95", country: "Myanmar" },
  { code: "+98", country: "Iran" },
  { code: "+212", country: "Morocco" },
  { code: "+213", country: "Algeria" },
  { code: "+216", country: "Tunisia" },
  { code: "+218", country: "Libya" },
  { code: "+220", country: "Gambia" },
  { code: "+221", country: "Senegal" },
  { code: "+233", country: "Ghana" },
  { code: "+234", country: "Nigeria" },
  { code: "+254", country: "Kenya" },
  { code: "+255", country: "Tanzania" },
  { code: "+256", country: "Uganda" },
  { code: "+260", country: "Zambia" },
  { code: "+263", country: "Zimbabwe" },
  { code: "+351", country: "Portugal" },
  { code: "+352", country: "Luxembourg" },
  { code: "+353", country: "Ireland" },
  { code: "+354", country: "Iceland" },
  { code: "+355", country: "Albania" },
  { code: "+356", country: "Malta" },
  { code: "+357", country: "Cyprus" },
  { code: "+358", country: "Finland" },
  { code: "+359", country: "Bulgaria" },
  { code: "+370", country: "Lithuania" },
  { code: "+371", country: "Latvia" },
  { code: "+372", country: "Estonia" },
  { code: "+373", country: "Moldova" },
  { code: "+374", country: "Armenia" },
  { code: "+375", country: "Belarus" },
  { code: "+377", country: "Monaco" },
  { code: "+380", country: "Ukraine" },
  { code: "+381", country: "Serbia" },
  { code: "+385", country: "Croatia" },
  { code: "+386", country: "Slovenia" },
  { code: "+420", country: "Czech Republic" },
  { code: "+421", country: "Slovakia" },
  { code: "+852", country: "Hong Kong" },
  { code: "+886", country: "Taiwan" },
  { code: "+961", country: "Lebanon" },
  { code: "+962", country: "Jordan" },
  { code: "+963", country: "Syria" },
  { code: "+964", country: "Iraq" },
  { code: "+965", country: "Kuwait" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+967", country: "Yemen" },
  { code: "+968", country: "Oman" },
  { code: "+971", country: "United Arab Emirates" },
  { code: "+972", country: "Israel" },
  { code: "+973", country: "Bahrain" },
  { code: "+974", country: "Qatar" },
  { code: "+976", country: "Mongolia" },
  { code: "+977", country: "Nepal" },
];
